import useMutation from 'api/hooks/useMutation';
import useTrackWithUser from 'api/hooks/useTrackWithUser';
import permissions from 'api/Apollo/permissions';
import { SCHEMA_LIBRARY_WITH_VERSIONS_QUERY } from 'api/schema-libraries/useQuerySchemaLibraryWithVersions';

import {
  mutation as updateSchemaLibraryVersion,
  buildVariables as buildSchemaLibraryVersionVariables,
} from './update-schema-library-version-mutation-builder';

export default function useUpdateSchemaLibraryVersion(options = {}) {
  const [trackWithUser] = useTrackWithUser('schema_library_version_updated');
  const [executeMutation, response] = useMutation(updateSchemaLibraryVersion, {
    ...options,
    refetchQueries: [SCHEMA_LIBRARY_WITH_VERSIONS_QUERY],
    context: { permission: permissions.updateSchemas },
  });

  const updateSchemaLibraryVersionMutation = async ({ id, status }) => {
    const response = await executeMutation({
      variables: buildSchemaLibraryVersionVariables({ id, status }),
    });

    if (!response.errors) {
      trackWithUser();
    }

    return response;
  };

  return [updateSchemaLibraryVersionMutation, response];
}
